import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { API, DeviceFullDTO } from '../../../../services/api/api';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService, ToastType } from '../../../../services/toaster/toaster.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-device-calibration',
  templateUrl: './sb-device-calibration.component.html',
  styleUrls: ['./sb-device-calibration.component.scss'],
  standalone: false,
})
export class SbDeviceCalibrationComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  displayTime: number;
  @Input() device: DeviceFullDTO;

  constructor(
    public api: API,
    public modalNavigation: ModalNavigationService,
    public translate: TranslateService,
    public toaster: ToasterService,
    private destroyRef: DestroyRef
  ) {
    this.displayTime = 600;
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  showImage() {
    this.api
      .ss_nm_Device_executeCommandShowCalibrationImage(this.device.id, { millis: this.displayTime ? this.displayTime * 1000 : 600000 })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {
          this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful'));
        },
        error: () => {
          this.toaster.toast(ToastType.DANGER, this.translate.instant('lang.globals.error'));
        },
      });
  }

  reject() {
    this.goBack();
  }

  goBack() {
    this.modalNavigation.goBack();
  }

  hideImage() {
    this.api
      .ss_nm_Device_executeCommandHideCalibrationImage(this.device.id)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {
          this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful'));
        },
        error: () => {
          this.toaster.toast(ToastType.DANGER, this.translate.instant('lang.globals.error'));
        },
      });
  }
}
